<template>
  <div class="password">
    <validation-observer ref="observer">
      <div class="d-placeitem d-placecontent is-flex">
        <div class="column is-12">
          <h2
            class="is-size-4 is-size-4-mobile has-margin-bottom-10-mobile has-text-weight-semibold"
          >
            {{ $t('password') }}
          </h2>
          <p class="text-14 pb-2">{{ $t('Please set a new password') }}</p>
          <div class="">
            <validation-provider
              v-slot="{ errors }"
              :name="$t('password')"
              rules="required|min:8"
              vid="password"
            >
              <label class="label is-size-7 has-text-grey">
                {{ $t('password') }}
                <span class="has-text-danger">*</span>
              </label>
              <div class="field has-addons mb-0">
                <div class="control is-expanded has-icons-left">
                  <input
                    v-model="formValues.password"
                    :class="{ 'is-danger': errors.length }"
                    class="input"
                    :type="showPassword ? 'text' : 'password'"
                    :placeholder="
                      from === 'survey' ? 'पासवर्ड बनाउनुहोस्' : $t('password')
                    "
                    @keyup.enter="setPassword"
                  />
                  <span class="icon is-left">
                    <vue-icon-base
                      height="16"
                      width="16"
                      :path="$options.icons[$kc('uni-padlock')]"
                    >
                    </vue-icon-base>
                  </span>
                </div>
                <div class="control">
                  <a
                    id="btn-show-password"
                    class="button"
                    @click="showPassword = !showPassword"
                  >
                    <vue-icon-base
                      height="16"
                      width="16"
                      :path="
                        $options.icons[
                          $kc(showPassword ? 'uni-eye' : 'uni-eye-slash')
                        ]
                      "
                    >
                    </vue-icon-base>
                  </a>
                </div>
              </div>
              <p class="field-error help is-danger">
                {{ errors[0] || fieldErrors.password }}
              </p>
            </validation-provider>
          </div>
          <div class="">
            <validation-provider
              v-slot="{ errors }"
              :name="$t('Password')"
              rules="required|confirmed:password"
            >
              <label class="label is-size-7 has-text-grey">
                {{ $t('Re-Enter Password') }}
                <span class="has-text-danger">*</span>
              </label>
              <div class="field has-addons mb-0">
                <div class="control is-expanded has-icons-left">
                  <input
                    v-model="formValues.confirmPassword"
                    :class="{ 'is-danger': errors.length }"
                    class="input"
                    :type="showConfirmPassword ? 'text' : 'password'"
                    :placeholder="$t('Re-Enter Password')"
                    @keyup.enter="setPassword"
                  />
                  <span class="icon is-left">
                    <vue-icon-base
                      height="16"
                      width="16"
                      :path="$options.icons[$kc('uni-padlock')]"
                    >
                    </vue-icon-base>
                  </span>
                </div>
                <div class="control">
                  <a
                    id="btn-confirm-password"
                    class="button"
                    @click="showConfirmPassword = !showConfirmPassword"
                  >
                    <vue-icon-base
                      height="16"
                      width="16"
                      :path="
                        $options.icons[
                          $kc(showConfirmPassword ? 'uni-eye' : 'uni-eye-slash')
                        ]
                      "
                    >
                    </vue-icon-base>
                  </a>
                </div>
              </div>
              <p class="field-error help is-danger">
                {{ errors[0] || fieldErrors.password }}
              </p>
            </validation-provider>
          </div>
          <div class="">
            <button
              :id="
                employer
                  ? 'btn-set-employer-password'
                  : 'btn-set-jobseeker-password'
              "
              :class="[employer ? 'is-employer' : 'is-jobseeker']"
              :disabled="formValues.password.length < 8"
              class="button has-text-white is-fullwidth"
              @click="setPassword"
              v-text="$t('Next')"
            ></button>
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import FormMixin from '@/mixins/veeValidate'
import VueIconBase from '@/components/Commons/VueIconBase'

import { uniUserCircle, uniEye, uniEyeSlash, uniPadlock } from '@/helpers/icons'
import { mapGetters, mapMutations } from 'vuex'

export default {
  icons: {
    uniUserCircle,
    uniEye,
    uniEyeSlash,
    uniPadlock
  },
  components: {
    VueIconBase
  },
  mixins: [FormMixin],
  props: {
    employer: {
      type: Boolean,
      default: false
    },
    from: {
      type: String,
      default: ''
    },
    jobseeker: {
      type: Boolean
    }
  },
  data() {
    return {
      showPassword: false,
      showConfirmPassword: false,
      formValues: {
        otp: '',
        phone_number: '',
        password: '',
        confirmPassword: '',
        email: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      currentPhoneNumber: 'signup/currentPhoneNumber',
      currentOtp: 'signup/currentOtp',
      currentCountryCode: 'signup/currentCountryCode',
      currentEmail: 'signup/currentEmail'
    })
  },
  methods: {
    ...mapMutations({
      updatePhoneNumber: 'signup/updatePhoneNumber',
      updateOtp: 'signup/updateOtp',
      updateEmail: 'signup/updateEmail'
    }),
    async setPassword() {
      if (await this.validateAllFields()) {
        if (this.currentCountryCode !== '+977') {
          this.$axios
            .$post('/api/v1/users/basic-jobseeker-register/', {
              phone_number: this.currentPhoneNumber,
              country: this.currentCountryName,
              password: this.formValues.password,
              email: this.currentEmail
            })
            .then(response => {
              this.$auth
                .loginWith('local', {
                  data: {
                    phone_number: this.currentPhoneNumber,
                    password: this.formValues.password
                  }
                })
                .then(response => {
                  this.notifyUser(this.$t('Successfully Logged In'))
                  this.$router.push(
                    this.localePath({
                      name: 'signup-prefered-location'
                    })
                  )
                })
            })
        } else {
          this.$axios
            .$put('/api/v1/users/set-password/', {
              password: this.formValues.password,
              phone_number: '977-' + this.currentPhoneNumber,
              otp: this.currentOtp
            })
            .then(response => {
              this.$auth
                .loginWith('local', {
                  data: {
                    phone_number: this.currentPhoneNumber,
                    password: this.formValues.password
                  }
                })
                .then(response => {
                  this.notifyUser(this.$t('Successfully Logged In'))
                  if (this.jobseeker === true) {
                    this.$router.push(
                      this.localePath({
                        name: 'signup-prefered-location'
                      })
                    )
                  } else if (this.employer === true) {
                    this.$router.push(
                      this.localePath({
                        name: 'signup-organization-details'
                      })
                    )
                  }
                })
            })
            .catch(error => {
              if (
                error &&
                error.response &&
                error.response.data &&
                error.response.data.non_field_errors
              ) {
                this.notifyError(error.response.data.non_field_errors[0])
              } else if (
                error &&
                error.response &&
                error.response.data &&
                error.response.data.password
              ) {
                this.notifyError(error.response.data.password[0])
              } else {
                this.notifyError(this.$t('Something went wrong'))
              }
            })
        }
      }
    }
  }
}
</script>
